export default "__VITE_ASSET__DSg8ZJXU__"